import React from "react";
import styled from "styled-components";

import Colors from "../../constants/colors";
import Fonts from "../../constants/fonts";
import Breakpoints from "../../constants/breakpoints";

const Container = styled.div`
  background-color: ${props => props.bgColor || Colors.Basic.gray_88};
  background-image: ${props => props.bgPattern || 'none'};
  height: 624px;
  padding-top: 120px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(19.4rem, 90rem) minmax(0, 1fr);
`;

const Info = styled.div`
  grid-row: 1 / 2;
  grid-column: 2 / 3;
  display: flex;
  flex-direction: column;
  padding-left: 4rem;
  padding-right: 4rem;
  padding-top: 80px;
  background-image: url(${props => props.bgImage});
  background-repeat: no-repeat;
  background-position-x: ${props => props.bgPosX || '100%'};
  background-position-y: ${props => props.bgPosY || '100%'};
  background-size: ${props => props.bgSize || 'auto 100%'};
  color: ${props => props.lightText ? Colors.Basic.white : 'inherit'};


  @media only screen and (max-width: ${Breakpoints.Width.laptop_medium}) {
    background-size: contain;
  }

  @media only screen and (max-width: ${Breakpoints.Width.laptop_small}) {
    padding-top: 40px;
  }

  @media only screen and (max-width: ${Breakpoints.Width.tablet}) {
    background-size: auto 75%;
    padding-left: 3rem;
    padding-right: 3rem;
    padding-top: 20px;
  }

  @media only screen and (max-width: ${Breakpoints.Width.mobile_large}) {
    background-size: auto 60%;
    background-position-x: 50%;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 10px;
  }
`;

const Title = styled.h1`
  font-family: ${Fonts.Font_family.title_condensed};
  font-size: 4.5rem;
  line-height: 1;
  font-weight: 100;
  margin-bottom: 36px;
  position: relative;

  &::after {
    content: "";
    background-color: ${Colors.Basic.orange_01};
    display: block;
    width: 30px;
    height: 2px;
    position: absolute;
    bottom: -8px;
  }
`;

const Description = styled.p`
  max-width: 33rem;
  margin-bottom: 40px;
`;

const MetaData = styled.div`
  display: flex;
  flex-direction: row;
`;

const MetaDataContainer = styled.div`
  font-family: ${Fonts.Font_family.title_condensed};
  letter-spacing: 1px;
  &:not(:last-child) {
    margin-right: 40px;
  }

  span {
    display: inline-block;
    &:first-child {
      color: ${props => props.lightText ? Colors.Basic.gray_75 : Colors.Text.project_meta_title};
      margin-right: 8px;
    }
  }
`;


const Banner = props => {
  return (
    <Container bgColor={props.bgColor} bgPattern={props.bgPattern} data-sal="fade" data-sal-duration="600">
      <Info 
        lightText={props.lightText}
        bgImage={props.bgImage}
        bgPosX={props.bgPosX}
        bgPosY={props.bgPosY}
        bgSize={props.bgSize}
        >
        <Title lightText data-sal="slide-up" data-sal-delay="400" data-sal-duration="800">{props.title}</Title>
        <Description lightText data-sal="slide-up" data-sal-delay="600" data-sal-duration="800">{props.description}</Description>
        <MetaData lightText>
          <MetaDataContainer lightText={props.lightText} data-sal="slide-left" data-sal-delay="800" data-sal-duration="800">
            <span>Year</span>
            <span>{props.year}</span>
          </MetaDataContainer>
          <MetaDataContainer lightText={props.lightText} data-sal="slide-left" data-sal-delay="1000" data-sal-duration="1000">
            <span>Role</span>
            <span>{props.role}</span>
          </MetaDataContainer>
        </MetaData>
      </Info>
    </Container>
  );
}

export default Banner;
